import React from "react";
import { useTranslation } from "react-i18next";
import TutorModel from "../../api/models/TutorModel";
import { classNames } from "../../helpers";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";

type CandidateTutorsTableProps = {
  tutors: TutorModel[];
  onSelectTutor?: (tutor: TutorModel | null) => void;
  selectedTutor?: TutorModel | null;
};
export default function CandidateTutorsTable(props: CandidateTutorsTableProps) {
  const { tutors, onSelectTutor = () => {}, selectedTutor } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.bookSession",
  });
  return (
    <table className="min-w-full divide-y divide-gray-300 shadow-sm rounded-md overflow-hidden">
      <thead className="bg-gray-100">
        <tr>
          <th
            scope="col"
            className="py-2 ltr:pl-16 rtl:pr-16 text-sm leading-4 font-medium text-gray-800 ltr:text-left rtl:text-right"
          >
            {t("tutor")}
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white flex flex-col max-h-56 overflow-y-auto">
        {!!tutors.length ? (
          React.Children.toArray(
            tutors.map((tutor) => (
              <tr>
                <td
                  className={classNames(
                    "flex items-center gap-6 py-2 mx-4",
                    tutor.id === selectedTutor?.id && "bg-gray-200"
                  )}
                >
                  <div className="">
                    <input
                      type="checkbox"
                      className="rounded border-gray-300 text-brandblue-600 focus:ring-brandblue-500 cursor-pointer"
                      value={tutor.id}
                      checked={tutor.id === selectedTutor?.id}
                      onChange={(e) => {
                        e.target.checked
                          ? onSelectTutor(tutor)
                          : onSelectTutor(null);
                      }}
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <UserProfilePictureAvatar
                      profilePictureUrl={tutor?.profile_picture_url}
                      className="w-10 h-10"
                      alt="tutor"
                    />
                  </div>
                  <div className="flex items-center">
                    <h3 className="text-base font-medium text-gray-700">
                      {tutor?.full_name}
                    </h3>
                  </div>
                </td>
              </tr>
            ))
          )
        ) : (
          <tr>
            <td className="flex items-center justify-center text-sm leading-6 font-normal bg-gray-50 text-gray-400 py-4">
              {t("tutorPlaceholder")}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
